/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { useStores } from '../../hooks/useStore';
import styles from './settings.module.css';
import { observer } from 'mobx-react';
import AxlStageTypes from '../../api/stageTypes/dto/AxlStageTypes';
import { useApi } from '../../hooks/useApi';
import Select from '../../components/UI/Select/Select';
import StageTypes, { TypesForStage } from '../../api/stageTypes/dto/StageTypes';
import { Button } from '../../components/UI/Button/Button';
import Separator from '../../components/UI/Separator/Separator';
import CreateStageTypestReq from '../../api/stageTypes/dto/CreateStageTypestReq';

const typesStageList = [
  { id: 'not_started', name: 'Не взято в работу' },
  { id: 'in_progress', name: 'В работе' },
  { id: 'no_answer', name: 'Не дозвон' },
  { id: 'leads_pool', name: 'Заделы' },
  { id: 'completed', name: 'Реализовано' },
  { id: 'failed', name: 'Не реализовано' },
];

const SettingsPage: React.FC = observer(() => {
  const api = useApi();
  const store = useStores();

  const [stagesTypes, setStagesTypes] = useState<StageTypes[]>([]);
  const [stagesAxl, setStagesAxl] = useState<AxlStageTypes[]>([]);

  const [stageIdAxl, setStageIdAxl] = useState<string>('');
  const [stageName, setStageName] = useState<string>('');
  const [selectedDealTypeStage, setSelectedDealTypeStage] =
    useState<TypesForStage>('not_started');

  const uploadStagesAxl = async () => {
    try {
      store.notificationsStore.showPreloader();
      const { body } = await api.stageTypes.getAxlStages();
      if (body) {
        setStagesAxl(body);
      }
    } catch (error) {
      store.notificationsStore.setError('Ошибка при загрузке этапов AXL');
    } finally {
      store.notificationsStore.hidePreloader();
    }
  };

  const uploadStagesTypes = async () => {
    try {
      store.notificationsStore.showPreloader();
      const { body } = await api.stageTypes.getAll();
      if (body) {
        setStagesTypes(body);
      }
    } catch (error) {
      store.notificationsStore.setError('Ошибка при загрузке этапов AXL');
    } finally {
      store.notificationsStore.hidePreloader();
    }
  };

  const deleteStageType = async (id: string) => {
    try {
      store.notificationsStore.showPreloader();
      await api.stageTypes.delete(id);
      setStagesTypes((prev) => prev.filter((stage) => stage.id !== id));
      store.notificationsStore.setNotifications('Этап успешно удален');
    } catch (error) {
      store.notificationsStore.setError('Ошибка при удалении этапа');
    } finally {
      store.notificationsStore.hidePreloader();
    }
  };

  const updateStage = async (id: string, data: CreateStageTypestReq) => {
    try {
      store.notificationsStore.showPreloader();
      await api.stageTypes.update(id, data);
      setStagesTypes((prev) =>
        prev.map((stage) => (stage.id === id ? { ...stage, ...data } : stage)),
      );
      store.notificationsStore.setNotifications('Этап успешно обновлен');
    } catch (error) {
      store.notificationsStore.setError('Ошибка при обновлении этапа');
    } finally {
      store.notificationsStore.hidePreloader();
    }
  };

  const createStage = async () => {
    try {
      store.notificationsStore.showPreloader();
      await api.stageTypes.create({
        stage_id: stageIdAxl,
        stage_name: stageName,
        type: selectedDealTypeStage,
      });
      store.notificationsStore.setNotifications('Этап успешно создан');
      await uploadStagesTypes();
    } catch (error) {
      store.notificationsStore.setError('Ошибка при создании этапа');
    } finally {
      store.notificationsStore.hidePreloader();
      setStageIdAxl('');
      setStageName('');
      setSelectedDealTypeStage('not_started');
    }
  };

  useEffect(() => {
    Promise.all([uploadStagesAxl(), uploadStagesTypes()]);
  }, []);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.pageName}>
          <div className={styles.top}>
            <div className={styles.title}>
              <h2>Настройки</h2>
            </div>
          </div>
        </div>

        <div>
          <h3>Создание типа сделки</h3>

          <div>
            <Separator />
            <div style={{ display: 'flex' }}>
              <Select
                style={{ margin: 5 }}
                selectedValue={stageIdAxl}
                listCategories={stagesAxl.map((axlStage) => ({
                  id: axlStage.id,
                  name: axlStage.name + ' | ' + axlStage.pipelineName,
                }))}
                onChange={(value) => {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  //@ts-ignore
                  setStageIdAxl(value.target.value as string);
                  setStageName(
                    stagesAxl.find(
                      (axlStage) =>
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-ignore
                        axlStage.id === (value.target.value as string),
                    )?.name || '',
                  );
                }}
              />

              <Select
                style={{ width: 300, margin: 5 }}
                selectedValue={selectedDealTypeStage}
                onChange={(value) => {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  //@ts-ignore
                  setSelectedDealTypeStage(value.target.value as TypesForStage);
                }}
                listCategories={typesStageList.map((type) => ({
                  id: type.id,
                  name: type.name,
                }))}
              />

              <Button
                onClick={() => createStage()}
                style={{ width: 200, margin: 5 }}
                appearance="auth"
              >
                Добавить
              </Button>
            </div>
          </div>

          <h3 style={{ marginTop: 30 }}>Текущие типы сделок</h3>

          {stagesTypes.length > 0 &&
            stagesTypes.map((stage) => (
              <div key={stage.id}>
                <Separator />
                <div style={{ display: 'flex' }}>
                  <Select
                    style={{ margin: 5 }}
                    selectedValue={stage.stage_id}
                    listCategories={stagesAxl.map((axlStage) => ({
                      id: axlStage.id,
                      name: axlStage.name + ' | ' + axlStage.pipelineName,
                    }))}
                    onChange={(value) => {
                      updateStage(stage.id, {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-ignore
                        stage_id: value.target.value,
                        stage_name:
                          stagesAxl.find(
                            (axlStage) =>
                              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                              //@ts-ignore
                              axlStage.id === (value.target.value as string),
                          )?.name || '',
                        type: stage.type as TypesForStage,
                      });
                    }}
                  />

                  <Select
                    style={{ width: 300, margin: 5 }}
                    selectedValue={stage.type}
                    onChange={(value) => {
                      updateStage(stage.id, {
                        stage_id: stage.stage_id,
                        stage_name: stage.stage_name,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-ignore
                        type: value.target.value as TypesForStage,
                      });
                    }}
                    listCategories={typesStageList.map((type) => ({
                      id: type.id,
                      name: type.name,
                    }))}
                  />

                  <Button
                    onClick={() => deleteStageType(stage.id)}
                    style={{ width: 200, backgroundColor: 'red', margin: 5 }}
                    appearance="auth"
                  >
                    Удалить
                  </Button>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
});

export default SettingsPage;
